import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export interface BetaBackupRequest {
  featureName: string;
  url: string;
  buildName?: string;
  version?: number;
}
export type BetaRequestedFeatures = Record<string, BetaBackupRequest>;

export enum BetaFeatureBuildName {
  BackupBuilds = 'BackupBuilds'
}

@Injectable({
  providedIn: 'root'
})
export class BetaRequestService {
  private http = inject(HttpClient);

  private readonly controllerPath = '/api/support';

  requestBetaBackup(body: BetaBackupRequest): Observable<null> {
    return this.http.post<null>(`${this.controllerPath}/request-beta-backup`, body);
  }

  requestBetaBackupDate(): Observable<boolean> {
    return this.http
      .get<{ requestBetaBuildDate: Date }>(`${this.controllerPath}/request-beta-backup-date`)
      .pipe(map((res) => !!res?.requestBetaBuildDate));
  }
}
